import axios from 'axios'

export async function getItems(category, league) {
    let url = `https://api.poe.watch/get?category=${category}&league=${league}`
    if (category == "hot") {
        url = "https://api.poe.watch/hot?league=" + league
    }
    if (category == "inscribed") {
        url = "https://api.poe.watch/inscribed?league=" + league
    }
    const response = await axios
        .get(url)
    let items = response.data;

    if (category == "hot") {
        items.sort(function (a, b) {
            if (a.change < b.change) {
                return 1;
            } else if (a.change > b.change) {
                return -1;
            }
            else return 0
        })
    } else {
        items.sort(function (a, b) {
            if (a.mean < b.mean) {
                return 1;
            } else if (a.mean > b.mean) {
                return -1;
            }
            else return 0
        })
    }
    return items
}